import { CircularProgress, Grid } from '@material-ui/core';
import { UPLOADING } from '../../../../content';

const UploadingSpinner = () => {
  return (
    <Grid container direction="row" spacing={2} alignItems="center">
      <Grid item>
        <CircularProgress size={24} />
      </Grid>
      <Grid item>{UPLOADING}</Grid>
    </Grid>
  );
};

export default UploadingSpinner;
